<div class="row">
  <div mat-dialog-header class="col-12">
    <h1>Calculate Cost/Value</h1>
  </div>
  <div>
    <mat-dialog-content class="dialog-container col-12">
      <form class="row" [formGroup]="investmentForm">
        <mat-form-field class="col-6">
          <mat-label>Investment Amount</mat-label>
          <input
            matInput
            [maskito]="dollarMask"
            [formControlName]="'investmentAmount'"
          />
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>Hypothetical Rate of Return (%)</mat-label>
          <input
            matInput
            [maskito]="percentMask"
            [formControlName]="'rateOfReturn'"
          />
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>Time Horizon</mat-label>
          <mat-select [formControlName]="'timeHorizon'">
            @for (year of timeHorizonOptions; track $index) {
              <mat-option [value]="year">
                {{ year }}{{ year === 20 ? '+' : '' }} year{{
                  year > 1 ? 's' : ''
                }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>Share Class Conversion Time Frame</mat-label>
          <mat-select [formControlName]="'conversionTimeFrame'">
            @for (year of shareClassTimeOptions; track $index) {
              <mat-option [value]="year">
                {{ year }} year{{ year > 1 ? 's' : '' }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field class="col-6">
          <mat-label>Order By</mat-label>
          <mat-select [formControlName]="'orderBy'">
            @for (order of orderByOptions; track $index) {
              <mat-option [value]="order.value">
                {{ order.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </form>
    </mat-dialog-content>
    <mat-dialog-actions class="col-12 buttons pull-right">
      <button type="button" mat-raised-button class="close" (click)="close()">
        Cancel
      </button>
      <button
        type="button"
        mat-raised-button
        color="accent"
        class="calculate"
        [disabled]="calcIsDisabled()"
        (click)="submit()"
      >
        Calculate
      </button>
    </mat-dialog-actions>
  </div>
</div>
